import 'bootstrap/dist/css/bootstrap.min.css';
import Form from 'react-bootstrap/Form';
import { Col, Container, Row, Button, Spinner, OverlayTrigger, Popover } from 'react-bootstrap';
import ChemComponent from '../ChemComponent';
import { withRouter } from '../withRouter';
import ChemEdit from '../ChemEdit';
import QueryTable from '../QueryTable';
import { PencilSquare, PlusSquare } from 'react-bootstrap-icons';

class AccessLevels extends ChemComponent {
  	constructor(props) {
		super(props);
		
		var search = {
			ACCESS_NAME: ''
		};
		
		var initialAccessLevelList = this.copyAccessLevelList();
		initialAccessLevelList.query.search = this.constructSearch(search);
		
		this.state = {
			renderKey: 1,
			accessLevelList: initialAccessLevelList,
			search: search,
			searchCount: null
		};
	}
	
	copyAccessLevelList() {
		var accessLevelListCopy = this.copyObject(accessLevelList);
		for (var i = 0; i < accessLevelList.columns.length; i++) {
			if (accessLevelList.columns[i].Header) {
				accessLevelListCopy.columns[i].Header = accessLevelList.columns[i].Header;
			}
			if (accessLevelList.columns[i].Cell) {
				accessLevelListCopy.columns[i].Cell = accessLevelList.columns[i].Cell;
			}
		}
		return accessLevelListCopy;
	}
	
	onChangeSearch(accessor, value) {
		var search = this.copyObject(this.state.search);
		this.setByAccessor(search, accessor, value);
		this.mergeState({ search: search });
	}
	
	onSubmitSearch(event) {
		var newAccessLevelList = this.copyAccessLevelList();
		newAccessLevelList.query.search = this.constructSearch(this.state.search);
		this.mergeState({ 
			accessLevelList: newAccessLevelList,
			searchCount: null,
			renderKey: this.state.renderKey + 1
		});
		if (event && event.nativeEvent && event.nativeEvent.submitter) event.nativeEvent.submitter.blur();
	}
	
	onSearchResult(data) {
		this.mergeState({
			searchCount: data.ResultCount
		});
	}
	
	constructSearch(data) {
		// construct search terms
		var search = {
			Operator: 'and',
			Children: []
		};

		if (!this.isEmpty(data.ACCESS_NAME)) search.Children.push({ Attribute: 'ACCESS_NAME', Operator: 'like', StringValue: '%' + data.ACCESS_NAME + '%' });
		
		if (search.Children.length === 0) return null;
		return search;
	}
	
	addAccessLevel() {
		this.props.navigate('/BuildingAccess/AccessLevels/new');
	}
	
	editAccessLevel(accessLevelId) {
		this.props.navigate('/BuildingAccess/AccessLevels/' + accessLevelId);		
	}
	
	render() {

		var exportData = this.createHiddenFormData({
			__RequestVerificationToken: this.props.user.antiForgeryToken,
			title: 'AccessLevels',
			columns: exportColumns,
			entity: 'ACCESS_LEVEL',
			search: this.constructSearch(this.state.search),
			order: 'ACCESS_NAME'
		});			

		return (<>
			<Container fluid>
				<Row>
				  <Col xs={12} style={{ paddingTop: '20px', marginBottom: '20px', border: '1px solid #ccc', borderRadius: 6, backgroundColor: '#FEFEFE' }}>
					<span style={{ fontSize: '18px', fontWeight: 'bold' }}>AccessLevels</span>
					<ChemEdit parent={this} columns={accessLevelSearch} data={this.state.search} renderKey={this.state.renderKey} 
					  onChange={(accessor, value) => this.onChangeSearch(accessor, value)} onSubmit={(event) => this.onSubmitSearch(event)} {...this.props}>
					  <Form.Group as={Row} style={{ borderTop: '1px solid #eee', paddingTop: 10, marginBottom: 10 }}>
						<Col xs={3} style={{ marginTop: 8}}>
							{this.isEmpty(this.state.searchCount) ? <Spinner animation='border' as='div' size='sm' style={{ marginRight: '4px' }} /> : this.state.searchCount} records found.
						</Col>
						<Col xs={1} style={{ marginTop: 6}}>
							<form action={this.getConfig().host + '/Home/Excel'} method='POST'>
								{exportData.map((excelFormField, index) => {
									return (<input key={index} type='hidden' name={excelFormField.name} value={excelFormField.value} />);
								})}
								<OverlayTrigger trigger="hover" overlay={<Popover><Popover.Header as="h3">Export to Excel</Popover.Header></Popover>}>
								  <input type='image' src={this.getConfig().host + '/Content/Icons/Excel.png'} style={{ paddingLeft: '20px' }} alt="Export to Excel" />
							    </OverlayTrigger>
							</form>
						</Col>
						<Col xs={1} style={{ marginTop: 6}}>
							<form action={this.getConfig().host + '/Home/Pdf'} method='POST'>
								{exportData.map((pdfFormField, index) => {
									return (<input key={index} type='hidden' name={pdfFormField.name} value={pdfFormField.value} />);
								})}
								<OverlayTrigger trigger="hover" overlay={<Popover><Popover.Header as="h3">Export to PDF</Popover.Header></Popover>}>
								  <input type='image' src={this.getConfig().host + '/Content/Icons/Pdf.png'} style={{ paddingLeft: '20px' }} alt="Export to PDF" />
							    </OverlayTrigger>
							</form>
						</Col>
						<Col xs={6}>
						  <Button id="update" variant="warning" type="submit" className="float-end">Search</Button>
						</Col>
					  </Form.Group>
					</ChemEdit>
				  </Col>
				</Row>
				<Row>
					<Col>
						<QueryTable renderKey={this.state.renderKey} parent={this} name='BuildingAccess_AccessLevels' table={this.state.accessLevelList}
							onResult={(data) => this.onSearchResult(data)} offsetHeight='200px' />
					</Col>
				</Row>
			</Container>
		</>);
	}
}

const accessLevelSearch = [
	{ Header: 'Name', accessor: 'ACCESS_NAME', row: 0, col: 0 }
];

const accessLevelList = {
	query: { entity: 'ACCESS_LEVEL', search: null, order: 'ACCESS_NAME' },
	pageSize: 20,
	columns: [
		{ Header: props => <PlusSquare style={{ cursor: 'pointer' }} onClick={() => props.parent.addAccessLevel()} />, accessor: 'id', 
			Cell: props => <PencilSquare style={{ cursor: 'pointer' }} onClick={() => props.parent.editAccessLevel(props.row.values.ACCESS_ID)} />, width: 25 },
		{ Header: 'ID', accessor: 'ACCESS_ID' },
		{ Header: 'Name', accessor: 'ACCESS_NAME', width: 150 },
		{ Header: 'View App', accessor: 'VIEW_APP', width: 150 },
		{ Header: 'Change Data', accessor: 'CHANGE_DATA', width: 150 },
		{ Header: 'Administrate', accessor: 'ADMIN_APP', width: 150 }
	]
};

const exportColumns = [
	{ Header: 'ID', accessor: 'ACCESS_ID', width: 5 },
	{ Header: 'Name', accessor: 'ACCESS_NAME', width: 10 },
	{ Header: 'View App', accessor: 'VIEW_APP', width: 10 },
	{ Header: 'Change Data', accessor: 'CHANGE_DATA', width: 10 },
	{ Header: 'Administrate', accessor: 'ADMIN_APP', width: 10 }
];

export default withRouter(AccessLevels);